export const en = {
  label: {
    max: 'max',
    ComingSoon: 'Coming Soon',
    Loading: 'Loading...',
    Shuffling: 'Shuffling the Cards',
    Connecting: 'Connecting...',
    Score: 'Score',
    OopsError: 'Oops, error occurred',
    AreUSureYouWantToLogout: 'Are you sure you want to log out?',
    Flop: 'Flop',
    Turn: 'Turn',
    River: 'River',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    fold: 'fold',
    call: 'call',
    check: 'check',
    bet: 'bet',
    raise: 'raise',
    Raise: 'Raise',
    Bet: 'Bet',
    Fold: 'Fold',
    AllIn: 'All in',
    Check: 'Check',
    Call: 'Call',
    TryingToReconnect: 'Trying to reconnect...',
    RotateScreen: 'Rotate screen',
    PrepareForNextHand: 'Prepare for the next hand',
    SmallBlind: 'Small Blind',
    BigBlind: 'Big Blind',
    ThirdBlind: 'Third Blind',
    Ante: 'Ante',
    You: 'You',
    Host: 'Host'
  },
  Position: {
    BTN: 'BTN',
    SB: 'SB',
    BB: 'BB',
    STR: 'STR',
    UTG: 'UTG',
    UTG1: 'UTG+1',
    UTG2: 'UTG+2',
    UTG3: 'UTG+3',
    HJ: 'HJ',
    CO: 'CO',
    You: 'You'
  },
  error: {
    NoRoomId: 'No room id',
    NoPlayerId: 'No player id',
    WaitYourTurnToReceiveData: 'Wait your turn to receive data',
    FailedToReceiveDataFromAI: 'Failed to receive data from AI',
    FailedToFetchData: 'Failed to fetch data',
    RequestSuspended: 'Request suspended'
  },
  button: {
    Yes: 'Yes',
    No: 'No',
    LogOut: 'Log out',
    GoBack: 'Go back to menu',
    ViewAll: 'View all',
    Back: 'Back'
  },
  NLHDrillsPage: {
    label: {
      NLHE: 'NLHE',
      Hands: 'Hands',
      Score: 'Score',
      Rate: 'Rate',
      Ante: 'Ante',
      Straddle: 'Straddle',
      BB: 'BB',
      Str: 'Str',
      PokerBasics: 'Poker Basics'
    }
  },
  LoadingPage: {
    label: {
      ShufflingCards: 'Shuffling the cards',
      DealingTheHands: 'Dealing the hands',
      StackingTheChips: 'Stacking the chips',
      CheckingTheBlinds: 'Checking the blinds',
      CountingThePot: 'Counting the pot',
      PreparingTheTable: 'Preparing the table',
      GettingTheDeckReady: 'Getting the deck ready',
      ShufflingTheDeck: 'Shuffling the deck',
      SettingTheStakes: 'Setting the stakes',
      ReadyToGoAllIn: 'Ready to go all-in?',
      ChatMessageTitle: 'Hi, I am your personal assistant',
      ChatMessageDescription:
        'You will see my comments at special moments of the game. I will give you recommendations and advice.'
    }
  },
  LoginPage: {
    label: {
      LinkSentToEmail: 'Link sent to email',
      Login: 'Login',
      OpenMessage:
        'Open the message in your email (it may be in the Spam folder) from AcePoker and click on the link. You will be granted access to your account.',
      CreatePersonalAccount:
        'Create your personal AcePoker account to save your progress, game statistics and level up your poker skills. We will send a special login link to your account to your email.',
      Mail: 'Mail to which the link was sent'
    },
    button: {
      ResendLink: 'Resend link',
      SendMeLoginLink: 'Send me login link',
      ExploreAcePokerFirst: 'Explore AcePoker First'
    },
    placeholder: {
      EnterEmail: 'Enter your email'
    }
  },
  LoginPopup: {
    label: {
      EnterVerificationCode: 'Enter your verification\ncode',
      ContinueWithEmail: 'Continue with an email',
      CreateAnAccount: 'Create an account',
      EnterCodeDescription: 'Enter the 4-digit code sent to your email',
      StartPlaying: 'to start playing',
      NeedHelp: 'Need help?',
      TakingABreak: 'Taking a break? Enter your email to save your assessment progress.',
      RecommendedForBestExperience: 'Recommended for best experience',
      ContinueWithoutSaving:
        'If you choose to continue without entering an email, the results of your assessment will be lost'
    },
    button: {
      SendCode: 'Send code',
      KeepPracticing: 'Keep Practicing',
      ContinueWithoutSaving: 'Continue without saving',
      SendVerificationCode: 'Send Verification Code',
      ResendCode: 'Resend code',
      ResendCodeTimer: 'Resend code in {time}',
      ContinueWithoutEmail: 'Continue without an account',
      GoToHomePage: 'Go to Home Page'
    },
    placeholder: {
      EnterEmail: 'Enter your email'
    }
  },
  GameplayInsights: {
    label: {
      Description: 'Find out how you performed during this game.',
      GoToHomePage: 'Go to Home Page',
      ViewStatistics: 'View Statistics'
    }
  },
  HomePage: {
    label: {
      Title: 'Why not try...',
      Cash: 'Cash',
      NLHE: 'NLHE',
      StraddleAnte: 'Straddle+Ante',
      ComingSoon: 'Coming Soon',
      Hi: 'Hi {name}!',
      WelcomeSubtitle: 'Let me give you a few suggestions on the best places to start...'
    },
    button: {
      QuickStart: 'Quick Start',
      StartAssessment: 'Start Assessment'
    },
    Assessment: {
      Title: 'General Assessment Drill',
      Description:
        'Practice poker by doing all possible situations. As Quint learns more about your gameplay, he will customise this drill to make sure you play through the situations to make the best improvements.'
    },
    Dashboard: {
      Header: 'Welcome back!',
      Title: 'Features',
      HeroSection: {
        GuestUserProgress: {
          Title: 'Ready to crush the table? Join QuintAI!',
          Description:
            'Track your progress, uncover leaks, and become a poker master with QuintAI.',
          LoginButton: 'Login / Sign Up'
        },
        QuintAI: {
          Title: 'How can I help you?',
          Cards: {
            0: 'How can I improve my rank?',
            1: 'Dive deeper in my statistics',
            2: "Tell me which positions I'm constantly losing from and what adjustments I should make to improve my overall game strategy"
          }
        },
        UserProgress: {
          RankDescription: 'Practice Rank',
          AssessmentNotStarted: {
            Title: 'Need to complete',
            Description: 'Assessment Game'
          },
          RankProgress: 'Rank Progress'
        }
      },
      RecommendedDrills: {
        Title: 'Recommended Drills',
        Subtitle: 'Handpicked drills to sharpen your game.',
        ViewAll: 'View all drills',
        EmptyState: {
          Title: 'Start a quick Poker Assessment and log-in',
          Subtitle: 'to get Hand picked Drill recommendations '
        }
      },
      ActiveCompeteTables: {
        Title: 'Active Compete Tables',
        Subtitle: "See who's online and start competing.",
        ViewAll: 'Play with friends & bots',
        EmptyState: {
          Title: 'Play your Poker Assessment and log-in',
          Subtitle: 'first to unlock access to live competitive tables'
        }
      },
      Modes: {
        assessment: {
          Title: 'What’s your Poker Rank?',
          TitleContinue: 'Continue Assessment',
          Subtitle:
            'Take a quick assessment to reveal your poker level, play style, and most common mistakes.',
          SubtitleContinue:
            'Continue your assessment to find out your play style and biggest mistakes.',
          Button: 'Start Assessment',
          ButtonContinue: 'Continue Assessment',
          Progress: 'Completion'
        },
        practice: {
          Title: 'Practice',
          Subtitle: 'Learn about your mistakes, and improve your game with tips and drills.',
          Button: 'Let’s Practice'
        },
        compete: {
          Title: 'Compete',
          Subtitle:
            'Test your skills against our advanced AI. Invite your friends to the challenge.',
          Button: 'Ready to Compete?'
        },
        analysis: {
          Title: 'Analyse',
          Subtitle:
            'Dive deeper into your statistics. See what was wrong and how to level up your game.',
          Button: 'Analyse Hands'
        },
        study: {
          Title: 'Study',
          Subtitle: 'Study poker by doing all possible situations.',
          Button: 'Start Study'
        },
        stats_results_ready: {
          Title: 'Your results are ready!',
          Subtitle: 'We’ve analyzed your gameplay and you can now view your results',
          Button: 'Check Your Results'
        },
        stats_results_awaiting: {
          Title: "What's your poker rank?",
          Subtitle: 'Your results are being calculated and will appear here.'
        }
      },
      EmptySectionPlaceholder: 'Nothing to see here yet!'
    }
  },
  NoLimitHoldem: {
    label: {
      handPractice: 'Zero hand practice | One hand practice | {count} hands practice',
      handSession: 'Zero hands session | One hand session | {count} hands session',
      moveSession: 'Zero actions session | One action session | {count} actions session',
      toNextRank: 'to next rank',
      SwipeDownToViewTheStrategyChart: 'Swipe down to view the Strategy Chart',
      SwipeRightToOpenTheMovesAndHandHistory: 'Swipe right to open the moves and hand history',
      SwipeLeftToCheckStatisticsAndProgress: 'Swipe left to check Statistics & Progress',
      TapTheScreenToCloseContinue: 'Tap the screen to close continue'
    },
    button: {
      Table: 'Table',
      Stats: 'Stats',
      History: 'History'
    }
  },
  Shortcut: {
    label: {
      BrowdserNotSupported: 'Browser not supported',
      AddAcePoker: 'Add AcePoker to Home Screen',
      Use: 'Use',
      Safari: 'Safari or',
      Chrome: 'Google Chrome to play on the web app',
      InstallPoker:
        'Install AcePoker web app on your iPhone for quick access and the best gaming experience.',
      Tap: 'Tap',
      homeScreen: 'and then "Add to Home Screen".'
    }
  },
  Drills: {
    label: {
      Title: 'Training Arena',
      CreatingDrill: 'Creating Drill...'
    }
  },
  DrillsMenu: {
    label: {
      TrainingArea: 'Training Area',
      StartingSpot: 'Starting Spot',
      PreflopAction: 'Preflop Action',
      Preflop: 'Preflop',
      Flop: 'Flop',
      Custom: 'Custom',
      Any: 'Any',
      RFI: 'RFI',
      vsOpen: 'vs Open',
      vs4bet: 'vs 4bet',
      vs5bet: 'vs 5bet'
    }
  },
  PokerTable: {
    label: {
      TotalPot: 'Total pot:',
      Settings: 'NLHE 50/100/200',
      OpenSeat: 'Open seat',
      AddBot: 'Add Bot',
      SitHere: 'Sit Here'
    },
    button: {
      Fold: 'Fold',
      Call: 'Call',
      Check: 'Check',
      AllIn: 'All-in',
      Bet: 'Bet',
      Raise: 'Raise',
      RaiseTo: 'Raise to',
      SitIn: "I'm back"
    }
  },
  SitInAttention: {
    title: 'Attention',
    description:
      'You cannot sit back in during an active hand. You will be seated after the current hand is completed.',
    button: 'Understood'
  },
  SuggestedActions: {
    label: {
      EV: 'EV'
    },
    button: {
      Hide: 'Hide',
      Help: 'Help'
    }
  },
  Statistic: {
    label: {
      Rank: 'Rank',
      toNextRank: 'to next rank',
      Analyse: 'Analysing moves',
      Aces: 'Aces',
      HandsPlayed: 'Hands played per Session',
      TotalHands: 'Total Hands Played',
      TotalEV: 'Total EV loss',
      AvgEV: 'Avg. EV loss/hand',
      Recommendation: 'Recommendation',
      MoveResult:
        'In this move, you made a mistake because you later lost 60% of the bank. You should not have raise'
    },
    button: {
      Session: 'Session',
      Total: 'Total'
    }
  },
  Strategy: {
    label: {
      Actions: 'Actions',
      EV: 'EV'
    }
  },
  Errors: {
    label: {
      Oops: 'Oops, sorry :(',
      RoomNotFound: 'The room does not exist or was deleted',
      LostConnection: 'Lost connection to AcePoker',
      ConnectionHasBeenLost: 'The connection has been lost.',
      Details: 'Details might be available in AcePoker logs',
      InvalidEmail:
        "Invalid email address. Ensure your email includes { '@' } and follows the correct format.",
      EnterCode: 'Incorrect code',
      InvalidCodeLength: 'Invalid code length',
      PlayerAlredySeated: 'PlayerAlredy seated'
    },
    button: {
      Restart: 'Restart',
      GoBack: 'Go back to menu',
      LeaveSession: 'Leave Session'
    }
  },
  OptionsMenu: {
    button: {
      Hints: 'Hints on Action Buttons',
      ShowCards: 'Show Opponent Cards',
      EndPractice: 'End Practice',
      LeaveTable: 'Leave Table',
      LeaveAndCloseTable: 'Leave & Close Table',
      CopyTableLink: 'Copy Link to Table',
      UpdateCommentaryParams: 'Update Commentary Params'
    }
  },
  EndSession: {
    label: {
      RankBenefits: 'Rank 4 allows you to play ${deposit} BB with profit',
      ImproveSkills: 'To improve your skills, we recommend playing the following drills',
      PokerTitle: 'Poker Basics TRF',
      Straddle: 'Straddle + ante',
      Blind: '200BB (100 Str)',
      Hands: 'Hands',
      Score: 'Score',
      Qualities: 'Qualities',
      BasicStatistics: 'Basic Statistics'
    },
    button: {
      NextPractice: 'Next Practice',
      Exit: 'Exit Practice',
      Analysis: 'Session Analysis',
      LeaveTheTable: 'Leave the table',
      CloseTheTable: 'Close the table for everyone'
    }
  },
  NewDrill: {
    label: {
      Title: 'New Drill',
      Table: 'Table & Bots',
      GameFormat: 'Game Format',
      TypeOfBots: 'Type of Bots',

      Game: 'Game',
      OtherOptions: 'Other Options',
      StartingSpot: 'Starting Spot',
      GameMode: 'Game Mode',
      CustomStartingSpot: 'Custom Starting Spot',
      EditCard: 'Edit card',
      TapCardToEdit: 'Tap any card to edit',

      Session: 'Session',
      All: 'All',

      SelectCards_flop: 'Select Flop cards',
      SelectCards_turn: 'Select Turn cards',
      SelectCards_river: 'Select River cards',

      FinishCreatingDrill: 'Finish creating the drill!',
      FinishCreatingDrillMsg: `Write your own name or use the name provided by QuintAI. Add a description so that you don't forget the parameters.`,
      Off: 'Off',

      preflop: 'Preflop',
      postflop: 'Postflop',
      sequence: 'Custom',
      'bombPot-postflop': 'Whole Round',
      'bombPot-sequence': 'Custom',

      NumberOfRaises: 'Number of Raises',
      NumberOfPreflopRaises: 'Number of Pre-Flop Raises',
      NumberOfPostflopRaises: 'Number of Post-Flop Raises',

      NumberOfOpponents: 'Number of Opponents',
      Opponents_1: 'Heads-up',
      'Opponents_2+': 'Multi-way',

      HeroPosition: 'Hero Position',
      PositionGroup_Blinds: 'Blinds',
      PositionGroup_EP: 'Early',
      PositionGroup_LP: 'Late',

      RelativeHeroPosition: 'Relative Hero Position',
      PositionAuthority_OOP: 'OOP',
      PositionAuthority_IP: 'IP',
      PositionAuthority_Any: 'Any'
    },
    tooltip: {
      GameFormat:
        'Game Format defines Game Type, Number of Seats at the table, Blinds and Antes of the game',
      StartingSpot: `Starting Spot options are:
- Preflop - your drill starts preflop and ends before dealing the Flop
- Postflop - your drill starts on the Flop with Preflop actions randomized
- Custom - you define other players' actions step by step until your decision point`,
      'bombPot-StartingSpot': `Starting Spot options are:
- Whole Round - your drill starts on flop
- Custom - you define other players' actions step by step until your decision point`,
      NumberOfOpponents: `Number of Opponents defines how many active opponents you will face:
- Heads-up - exactly one active opponent
- Multi-way - more than one active opponent`,
      HeroPosition: `Hero Position defines number of positions you can play in. Exact positions depend on the Game Format:
- Early - any early or middle position
- Late - any late position
- Blinds - any blind`,
      RelativeHeroPosition: `Relative Hero Position defines your position relative to the opponents:
- IP (In Position) - you are the last to act on any street
- OOP (Out Of Position) - any other situation that is not IP (you are not the last to act)`,
      NumberOfRaises: `Number of Raises defines how many raises there will be made before the action returns to you:
0 - there will be no raises made before the action returns to you
1 - there will be exactly 1 raise before the action returns to you
2+ - there will be 2 or more raises before the action returns to you`,
      GameMode: `Full Hand - allows playing the hand from the very beginning till the showdown
Street - you play from the current spot till the end of the current street
Spot - you face one decision only`,
      CustomStartingSpot: `Custom Starting Spot: you define other players' actions step by step until your decision point`,
      Session: `Session defines how many hands you will play in this drill`
    },
    button: {
      Reset: 'Reset',
      Save: 'Save',
      Clear: 'Clear',
      SaveAndStart: 'Save and Start',
      KeepRandom: 'Keep Random',
      Update: 'Update'
    },
    message: {
      SequenceCompleted: `It's impossible to create a drill with such a sequence. To play the drill, there must be at least 2 players at the table.`
    },
    placeholder: {}
  },
  CustomDrills: {
    label: {
      DeleteDrill: 'Do you really want to delete Drill?',
      DeleteDrillMsg:
        'This will delete the statistics of that drill, but will not change your ranking or other statistics. You will not be able to recover data for the deleted drill.',
      ResetDrill: 'Do you really want to reset all stats in this Drill?',
      ResetDrillMsg:
        'Resetting the statistics will not affect your rating, but the data of this drill will be erased forever. To get new statistics, you will need to play this drill again.'
    },
    button: {
      CreateNewDrill: 'Create New Drill',
      Manage: 'Manage',
      CloseManage: 'Close Manage',
      EditDrill: 'Edit Drill',
      ShareDrill: 'Share Drill',
      ResetStats: 'Reset Stats',
      Duplicate: 'Duplicate',
      Delete: 'Delete',
      NewDrill: 'New Drill',
      DeleteDrill: 'Delete Drill',
      ResetDrill: 'Reset Drill',
      Cancel: 'Cancel',
      StartPractice: 'Start Practice'
    },
    placeholder: {
      EmptyTitle: 'Create your first drill!',
      EmptyText:
        'Practice on your own situations from the game or create interesting moments that you want to hone for yourself.',
      EmptyHistoryTitle: 'There is no hand history yet',
      EmptyHistoryText: 'Play your first hand to see the history',
      NotFoundTitle: `Oops... You've never played a game like this before!`,
      NotFoundText: `This is not a problem! Create your own drill with the following parameters.`
    },
    message: {
      DrillCreated: 'Drill {name} created successfully',
      DrillUpdated: 'Drill {name} updated successfully',
      DrillDeleted: 'Drill deleted successfully',
      DrillDuplicated: 'Drill duplicated successfully',
      DrillLinkCopied: 'Link to the drill copied to clipboard',
      DrillReset: 'Drill statistics have been successfully reset',
      CanNotChange: 'Create your own Drill if you want to change the Drill settings'
    }
  },
  Practice: {
    label: {
      Practice: 'Practice'
    }
  },
  Compete: {
    label: {
      Title: 'Compete Mode',
      Lobby: 'Lobby',
      MyTables: 'My Tables',
      History: 'History',
      CreateTable: 'Create Table',
      CreateTableMessage: 'Customize the table settings and share it with other players.',
      AddTableName: 'Add table name',
      GameFormat: 'Game Format',
      PickYourNickname: 'Pick your nickname',
      YourStack: 'Your stack',
      SelectYourAvatar: 'Select your avatar',
      Players: 'Players',
      Requests: 'Requests',
      RequestIngress: 'Request Ingress',
      IntendedSeat: 'Intended Seat',
      Stack: 'Stack',
      Bots: 'Bots',
      ActivePlayers: 'Active Players',
      AddAIBot: 'Add AI Bot',
      Active: 'Active',
      NotActive: 'Not Active',
      TableClosed: 'Table has been closed',
      SessionLog: 'Session Log',
      Completion: 'Completion'
    },
    button: {
      CreateTable: 'Create Table',
      SitOut: 'Sit Out',
      StandUp: 'Stand Up',
      SessionLog: 'Session Log',
      CopyLinkToTable: 'Copy Link to Table',
      LeaveAndCloseTable: 'Leave & Close Table',
      LeaveTable: 'Leave Table',
      AddMoreAIBots: 'Add More AI Bots',
      Copy: 'Copy',
      Copied: 'Copied!',
      Edit: 'Edit',
      RemoveBot: 'Remove Bot',
      AddBot: 'Add Bot',
      BackToLobby: 'Back to Lobby',
      TransferOwnership: 'Transfer Ownership',
      FinishLater: 'Finish later'
    },
    placeholder: {
      EmptyLobbyTitle: 'No tables available',
      EmptyLobbyText: 'Create a new table or join an open table.',
      EmptyMyTablesTitle: 'No active tables available',
      EmptyMyTablesText: 'Create a new table or join an open table.',
      EmptyHistoryTitle: 'You have not yet played a game in this mode.',
      EmptyHistoryText: 'Here you will find the history of the games in the compete mode.',
      Nickname: 'Nickname',
      StackAmountPlaceholder: 'Amount you want to set',
      NoPlayersConnected: 'No players connected yet',
      NoBotsConnected: 'No bots connected yet'
    },
    message: {
      CopyLink: 'Click below to copy the link and send to your friends.',
      LinkCopied:
        'The table invitation link has been successfully added to the clipboard. Send the link to other participants.',
      PlayFreeOnlinePoker: 'Play free online poker with your friends and AI bots.',
      BotRemoved: 'Bot Removed',
      BotRemovedDetails: 'Bot will be removed after the hand finishes.',
      OwnershipTransfered: 'Ownership Transfered',
      OwnershipTransferedDetails: 'Ownership has been transfered successfully',
      StackUpdated: 'Stack Updated',
      BotStackUpdated: 'The bot`s stack will be updated after the hand is finished.',
      PlayerStackUpdated: 'The player`s stack will be updated after the hand is finished.',
      NicknameRequired: 'Nickname is required',
      NicknameMinLength: 'Nickname must be at least 2 characters long',
      NicknameMaxLength: 'Nickname must be at most 14 characters long',
      StackRequired: 'Stack is required'
    }
  },
  Bots: {
    label: {
      GTO: 'GTO',
      TAG: 'TAG',
      LAG: 'LAG',
      phil: 'Phil Ivey AI'
    },
    message: {
      GTO: 'Clear actions; Minimal bluffing and aggression.',
      TAG: 'Optimal AI with few bluffs and good game reading.',
      LAG: 'Clear actions; Minimal bluffing and aggression.',
      phil: 'A professional player; Good combinations and aggressive play.'
    }
  },
  WelcomeModal: {
    label: {
      HowGoodYouAreInPoker: 'How good are you in poker?',
      HowGoodYouAreInPokerDescription:
        'Play some poker against our AI and find out! Your hands will be analyzed after you complete the assessment'
    },
    button: {
      SkipForNow: 'Skip for now',
      TakeAssessment: 'Take Assessment'
    }
  },
  CongratulationsModal: {
    label: {
      Title: 'Congratulations!',
      Description: 'You finished your assessment! Now let’s see your personalised statistics.'
    },
    button: {
      ViewStats: 'View Statistics'
    }
  },
  DataFetchingModal: {
    label: {
      Title: 'Just a moment...',
      Description: 'Your statistics are being generated.',
      TakingLonger: 'It is taking longer than expected.'
    },
    button: {
      ContinueWaiting: 'Keep Waiting',
      GoHome: 'Go Home'
    }
  },
  TableLeaveAttentionModal: {
    label: {
      Title: 'Attention!',
      Description: `You can't leave the table during the hand — you'll stand up automatically once the hand is over`
    },
    button: {
      Okay: 'Okay'
    }
  },
  TableStandUpAttentionModal: {
    label: {
      Title: 'Attention!',
      Description: `You can’t stand up during the hand — it will happen automatically once the hand is over`
    },
    button: {
      Okay: 'Okay'
    }
  },
  TableSitOutAttentionModal: {
    label: {
      Title: 'Attention!',
      Description: `You can’t sit out during the hand — it will happen automatically once the hand is over`
    },
    button: {
      Okay: 'Okay'
    }
  },
  TableSitInAttentionModal: {
    label: {
      Title: 'Attention!',
      Description: `You can’t sit in during the hand — it will happen automatically once the hand is over`
    },
    button: {
      Okay: 'Okay'
    }
  }
}
